import WeatherHealthBadge from "./WeatherHealthBadge";
import { formatDateTime } from "../../users/adminUserFormatters";

function MetricRow({ label, value }) {
  if (value === undefined || value === null || value === "") {
    return null;
  }

  return (
    <div className="weather-source-detail__metric">
      <span className="weather-source-detail__metric-label">{label}</span>
      <span className="weather-source-detail__metric-value">
        {typeof value === "object" ? JSON.stringify(value) : String(value)}
      </span>
    </div>
  );
}

const WeatherSourceIdeamDiscoveryResult = ({ result }) => {
  if (!result) {
    return null;
  }

  const discovery = result.result || result;
  const status = discovery.status;

  return (
    <section className="weather-source-detail__section weather-source-discovery-result">
      <h3>Latest IDEAM discovery</h3>
      <div className="weather-source-detail__status-row">
        <WeatherHealthBadge status={status} />
      </div>
      {discovery.message ? (
        <p className="weather-source-detail__message">{discovery.message}</p>
      ) : null}
      <MetricRow label="Checked at" value={formatDateTime(discovery.checkedAt)} />
      <MetricRow
        label="Response time"
        value={
          discovery.responseTimeMs != null ? `${discovery.responseTimeMs} ms` : "—"
        }
      />
      <MetricRow
        label="Success"
        value={discovery.isSuccess === undefined ? "—" : discovery.isSuccess ? "Yes" : "No"}
      />
      <MetricRow
        label="Configured layer ID"
        value={discovery.configuredLayer?.configuredLayerId ?? "—"}
      />
      <MetricRow
        label="Configured layer found"
        value={
          discovery.configuredLayer?.configuredLayerFound === undefined
            ? "—"
            : discovery.configuredLayer.configuredLayerFound
              ? "Yes"
              : "No"
        }
      />
      <MetricRow
        label="Suggested layer"
        value={
          discovery.suggestedLayer
            ? `${discovery.suggestedLayer.id} — ${discovery.suggestedLayer.name}`
            : "—"
        }
      />
      <MetricRow label="Service map name" value={discovery.service?.mapName} />
      <MetricRow label="Layer count" value={discovery.service?.layerCount} />
      {discovery.warnings?.length ? (
        <MetricRow label="Warnings" value={discovery.warnings.join("; ")} />
      ) : null}
      {discovery.errors?.length ? (
        <MetricRow label="Errors" value={discovery.errors.join("; ")} />
      ) : null}
      {discovery.candidateLayers?.length ? (
        <div className="weather-source-detail__metric">
          <span className="weather-source-detail__metric-label">Candidate layers</span>
          <ul className="weather-source-detail__metric-list">
            {discovery.candidateLayers.map((layer) => (
              <li key={layer.id}>
                {layer.id}: {layer.name} (score {layer.candidateScore})
              </li>
            ))}
          </ul>
        </div>
      ) : null}
      {discovery.endpoint?.metadataUrl ? (
        <MetricRow label="Metadata URL" value={discovery.endpoint.metadataUrl} />
      ) : null}
    </section>
  );
};

export default WeatherSourceIdeamDiscoveryResult;
